"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKycVerified = exports.clearAuthenticatedFacetec = exports.setAuthenticatedFacetec = exports.getCurrentUserState = exports._devMode = void 0;
var user_profile_1 = require("../features/slices/user-profile");
var store_1 = require("../store");
// export interface FacetecRuntimeState {
//   authenticated?: boolean;
//   actionAuthenticated?: boolean;
// }
// type ExtendedUser = (User & { [key: string]: any }) & {
//   facetec?: FacetecRuntimeState;
// };
// const cloneProfile = (): ExtendedUser | null => {
//   const profile = store.getState().userProfile.profile;
//   if (!profile || typeof profile !== "object") {
//     return null;
//   }
//   return { ...(profile as Record<string, any>) } as ExtendedUser;
// };
// const writeProfile = (profile: ExtendedUser | null): void => {
//   store.dispatch(setFirebaseUserProfile(profile as User | null));
// };
exports._devMode = process.env.NODE_ENV === "development";
var getCurrentUserState = function () {
    var profile = store_1.store.getState().userProfile.profile;
    if (!profile || typeof profile !== "object") {
        return null;
    }
    return profile;
};
exports.getCurrentUserState = getCurrentUserState;
var setAuthenticatedFacetec = function (authenticated, actionAuthenticated) {
    store_1.store.dispatch((0, user_profile_1.setFaceTecActions)({
        authenticated: authenticated,
        actionAuthenticated: actionAuthenticated,
    }));
};
exports.setAuthenticatedFacetec = setAuthenticatedFacetec;
var clearAuthenticatedFacetec = function () {
    store_1.store.dispatch((0, user_profile_1.setFaceTecActions)({
        authenticated: false,
        actionAuthenticated: false,
    }));
};
exports.clearAuthenticatedFacetec = clearAuthenticatedFacetec;
// Read Redux first because it's set in-memory on a successful FaceTec run
// before the Firestore profile listener has caught up; otherwise the user
// would briefly re-loop on the KYC step after a fresh verification.
var isKycVerified = function (reduxUser, firebaseProfile) {
    if ((reduxUser === null || reduxUser === void 0 ? void 0 : reduxUser.SumSubApproved) === true)
        return true;
    if ((firebaseProfile === null || firebaseProfile === void 0 ? void 0 : firebaseProfile.SumSubApproved) === true)
        return true;
    return false;
};
exports.isKycVerified = isKycVerified;
// export const overwriteUserState = (state: ExtendedUser | null): void => {
//   writeProfile(state);
// };
// export const mergeUserState = (updates: Partial<ExtendedUser>): void => {
//   if (!updates || Object.keys(updates).length === 0) {
//     return;
//   }
//   const current = cloneProfile() ?? ({} as ExtendedUser);
//   const merged = { ...current, ...updates } as ExtendedUser;
//   writeProfile(merged);
// };
// interface FacetecProfileUpdates {
//   facetecDBRef?: string;
//   SumSubApproved?: boolean;
//   faceMatchUserInfo?: IFaceMatchUserInfo;
//   authenticated?: boolean;
//   actionAuthenticated?: boolean;
//   facetec?: FacetecRuntimeState;
// }
// export const updateFacetecState = (updates: FacetecProfileUpdates): void => {
//   if (!updates || Object.keys(updates).length === 0) {
//     return;
//   }
//   const current = cloneProfile() ?? ({} as ExtendedUser);
//   const next: ExtendedUser = { ...current };
//   if (Object.prototype.hasOwnProperty.call(updates, "facetecDBRef")) {
//     next.facetecDBRef = updates.facetecDBRef;
//   }
//   if (Object.prototype.hasOwnProperty.call(updates, "SumSubApproved")) {
//     next.SumSubApproved = updates.SumSubApproved;
//   }
//   if (Object.prototype.hasOwnProperty.call(updates, "faceMatchUserInfo")) {
//     next.faceMatchUserInfo = updates.faceMatchUserInfo;
//   }
//   const facetec: FacetecRuntimeState = { ...(next.facetec ?? {}) };
//   if (updates.facetec) {
//     Object.assign(facetec, updates.facetec);
//   }
//   if (Object.prototype.hasOwnProperty.call(updates, "authenticated")) {
//     facetec.authenticated = updates.authenticated;
//   }
//   if (Object.prototype.hasOwnProperty.call(updates, "actionAuthenticated")) {
//     facetec.actionAuthenticated = updates.actionAuthenticated;
//   }
//   if (Object.keys(facetec).length > 0) {
//     next.facetec = facetec;
//   } else {
//     delete next.facetec;
//   }
//   writeProfile(next);
// };
// export const updateKycState = (updates: {
//   faceMatchUserInfo?: IFaceMatchUserInfo;
//   SumSubApproved?: boolean;
// }): void => {
//   if (!updates || Object.keys(updates).length === 0) {
//     return;
//   }
//   const current = cloneProfile() ?? ({} as ExtendedUser);
//   const next: ExtendedUser = { ...current };
//   if (Object.prototype.hasOwnProperty.call(updates, "faceMatchUserInfo")) {
//     next.faceMatchUserInfo = updates.faceMatchUserInfo;
//   }
//   if (Object.prototype.hasOwnProperty.call(updates, "SumSubApproved")) {
//     next.SumSubApproved = updates.SumSubApproved;
//   }
//   writeProfile(next);
// };
// export const resetUserState = (): void => {
//   writeProfile(null);
// };
